import bookappointmentApi from '../../../api/bookappointment-api';

const SHOW_TIMES_TA = 'FIOK_KIVALASZTASA';
const RESERVATION_TA = 'IDOPONT_KIVALASZTASA';
const DATA_MANAGEMENT_TA = 'ADATKEZELES_LINK';
const TYPE_TA = 'UGYF_TIPUS';
const CLICK_TYPES = {
	PIN: Symbol('PIN'),
	LIST: Symbol('LIST')
};
let timeReservationTypeTaObject = null;

const setType = (timeReservationType) => {
	timeReservationTypeTaObject = {
		name: TYPE_TA,
		value: timeReservationType
	};
};
const sendShowTimesTa = (branchSelectionMethod) => {
	const results = [timeReservationTypeTaObject];
	const taData = { eventType: SHOW_TIMES_TA, dataElements: results };
	if (branchSelectionMethod == CLICK_TYPES.PIN) {
		taData.dataElements.push({ name: 'PIN_KATTINTAS', value: 'igen' });
	} else if (branchSelectionMethod == CLICK_TYPES.LIST) {
		taData.dataElements.push({ name: 'LISTA_KATTINTAS', value: 'igen' });
	}
	bookappointmentApi.sendTa(taData);
};
const sendReservationTa = () => {
	const results = [timeReservationTypeTaObject];
	const taData = { eventType: RESERVATION_TA, dataElements: results };
	bookappointmentApi.sendTa(taData);
};
const sendDataManagementTa = () => {
	const results = [timeReservationTypeTaObject];
	const taData = { eventType: DATA_MANAGEMENT_TA, dataElements: results };
	return bookappointmentApi.sendTa(taData);
};
export const useTa = () => {
	return {
		CLICK_TYPES,
		setType,
		sendShowTimesTa,
		sendReservationTa,
		sendDataManagementTa
	};
};
